export const USE_CASES_BANNER_TEXT = ['Have a specific problem?', 'Let’s see how we can solve it.'];
export const USE_CASES_BUTTON_TEXT = 'Contact Us';
